import { makeStyles, shorthands, Switch, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  // Gray when Inactive. Fluent's own unchecked track is a neutral outline that
  // reads as "disabled" beside a filled blue one, so the off state gets a
  // filled gray of its own; the checked state keeps Fluent's brand blue.
  toggle: {
    '& .fui-Switch__input:not(:checked) ~ .fui-Switch__indicator': {
      color: tokens.colorNeutralForeground3,
      backgroundColor: tokens.colorNeutralBackground5,
      ...shorthands.borderColor(tokens.colorNeutralStroke1),
    },
  },
})

/**
 * THE ACTIVE / INACTIVE TOGGLE at the foot of every References and Rules editor,
 * inline with Cancel and Save (owner, 2026-09-29, D-201: "Rather than the
 * dropdown picker, let's make this a toggle that sits at the bottom of the
 * pop-up, inline with Cancel and Save. It should light-up blue when set to
 * Active and be gray or whatever when set to Inactive").
 *
 * It replaces the Status dropdown each editor carried in its body. Shown on
 * EDIT only, as the dropdown was: a new record is Active by definition. The
 * caller places it in a `<DialogActions position="start">` beside the dialog's
 * own actions, which is what puts it on the same row as Cancel and Save.
 *
 * NOT FOR VEHICLES: a vehicle's Status is the fleet's own In Service / Out of
 * Service / Sold, three values, so that editor keeps its dropdown.
 *
 * The label names the current state rather than asking a question, so the
 * reader sees "Active" or "Inactive" without having to interpret the switch.
 */
export function StatusToggle({
  value,
  onChange,
  disabled,
  title,
}: {
  value: boolean
  onChange: (isActive: boolean) => void
  disabled?: boolean
  /** What switching it off also does, where that is worth saying. */
  title?: string
}) {
  const s = useStyles()
  return (
    <Switch
      className={s.toggle}
      checked={value}
      disabled={disabled}
      title={title}
      label={value ? 'Active' : 'Inactive'}
      onChange={(_, d) => onChange(d.checked)}
    />
  )
}
